import config from '../config';

const appConfig = config();

const apiBewell = appConfig.auth_prefix;
const { v1 } = appConfig.apiVersion;

export default class AuthService {
  constructor(client) {
    this.client = client;
  }

  apiBewellAuth() {
    return this.client.get(`${apiBewell}${v1}`);
  }

  allUser() {
    return this.client.get(`${apiBewell}${v1}/user`);
  }

  authUser(payload) {
    return this.client.get(`${apiBewell}${v1}/user/`, payload);
  }

  updateUser(payload) {
    return this.client.patch(`${apiBewell}${v1}/user/`, payload);
  }

  // Uses template literal with backtick quotes around payload — matches original behavior
  userState(payload) {
    return this.client.patch(`${apiBewell}${v1}/user/\`${payload}\`/active_user`);
  }

  tokenValidation() {
    return this.client.get(`${apiBewell}${v1}/auth/token_validation`);
  }

  tokenRefresh() {
    return this.client.post(`${apiBewell}${v1}/auth/refresh_token`);
  }

  deleteTokens() {
    return this.client.post(`${apiBewell}${v1}/auth/delete_tokens`);
  }

  deleteCookie() {
    return this.client.get(`${apiBewell}${v1}/auth/delete_cookie`);
  }

  ValidationCookie() {
    return this.client.post(`${apiBewell}${v1}/auth/existing_token`);
  }

  authRegister() {
    return this.client.post(`${apiBewell}${v1}/auth/register`);
  }

  authLogin(payload) {
    return this.client.post(`${apiBewell}${v1}/auth/login`, payload);
  }

  resetMail(payload) {
    return this.client.post(`${apiBewell}${v1}/reset`, payload);
  }

  resetPassword(payload, token) {
    return this.client.get(`${apiBewell}${v1}/reset/${payload}/${token}`);
  }

  CreateResetPassword(payload, id, token) {
    return this.client.post(`${apiBewell}${v1}/reset/${id}/${token}`, payload);
  }

  getOneUserById(id) {
    return this.client.get(`${apiBewell}${v1}/user/${id}`);
  }
}
